import Page404 from '../components/Errors/Page404';

export default function NotFound() {
  return <Page404 />;
}
